import React, { useMemo } from 'react'
import { required } from 'react-admin'
import { MainProduct } from 'services/api/entities/catalog/mainProduct/types/internal/mainProduct-models'
import { useKGetList } from 'services/hooks/useKGetList'
import { getNameFromServicesName } from 'services/utils/name-maps'
import { ProductServiceName } from 'types/common'
import BriefQuestionArrayInput from 'ui-shared/FormComponents/BriefQuestionArrayInput'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import KFileInput from 'ui-shared/WrappedInputs/KFileInput'
import KFormTab from 'ui-shared/WrappedInputs/KFormTab'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'

type Props = {
  servName: ProductServiceName
  children?: React.ReactNode
}

const BaseCfgTab: React.FC<Props> = ({ servName, children, ...rest }) => {
  const name = useMemo(() => getNameFromServicesName(servName), [servName])
  const productChoices = useKGetList<MainProduct>(name)
  return (
    <KFormTab {...rest} label={`form.tabs.${servName}`}>
      {children}
      <KFileInput
        multiple
        label="Kampaayer Documents"
        accept="application/pdf,.xls,.xlsx,.docx"
        source={`${servName}.eventKampaayerDocs`}
      />
      <Kdivider title="Service Time Limit" />
      <KNumberInput
        source={`${servName}.advanceReservationMin`}
        label="form.fields.advanceReservationMin"
        validate={required()}
      />
      <Kdivider title="Brief Questions" />
      <BriefQuestionArrayInput
        source={`${servName}.brief`}
        productChoices={productChoices}
      />
    </KFormTab>
  )
}

export default BaseCfgTab
